export enum EROLES {
    PROVIDER = "Provider",
    CDI_REVIEWER = "CDI Reviewer",
    MEDICAL_ASSISTANT = "Medical Assistant"
}
